import { CALL_API, METHODS } from 'app/react/state/middleware/api'
import * as Endpoints from './endpoints'
import * as Schemas from './schemas'

export const ALL_REQUEST = 'ALL_BOOKING_ATTENDEES_REQUEST';
export const ALL_SUCCESS = 'ALL_BOOKING_ATTENDEES_SUCCESS';
export const ALL_FAILURE = 'ALL_BOOKING_ATTENDEES_FAILURE';
export const ALL_TYPES = [
    ALL_REQUEST,
    ALL_SUCCESS,
    ALL_FAILURE
];

export const fetchAll = (accountId, eventId, bookingId) => ({
    [CALL_API]: {
        types: ALL_TYPES,
        method: METHODS.GET,
        endpoint: Endpoints.fetchAll(eventId, bookingId),
        schema: Schemas.entities
    },
    accountId,
    eventId,
    bookingId
});



